import TariffsSection from './Component';

export default TariffsSection;